import React from 'react';
import Info from '../Symbols/Info';
import Row from '../Symbols/Row';
import Button from '../Symbols/Button';
import Result from './Result';
import Form from '../Symbols/Form';
import InputSelect from '../Symbols/InputSelect';
import InputCurrency from '../Symbols/InputCurrency';
import Wrapper from '../Symbols/Wrapper';
import { PersonsVariant, CitySizeVariant, ContractVariant } from '../bydleni/Options';
import { YEARS_ACCOMODATION } from '../LegalParameters/Constants';

const years = YEARS_ACCOMODATION.map(year => ({ name: year, value: year }));

const emptyFunc = () => {};

export default props => {
	const {
		validateHandler = emptyFunc,
		changeHandler = emptyFunc,
		errors = {},
		state: { persons, citySize, contract, cost, income, year },
		result = null,
		onSubmit,
		reset,
	} = props;

	return (
		<Wrapper>
			<Form onSubmit={onSubmit} title="Kalkulačka - Příspěvek na bydlení">
				<InputSelect
					label="Výpočet pro rok:"
					name="years"
					value={year}
					onChange={changeHandler('year')}
					onBlur={validateHandler('year')}
					passedProps={{ 'data-cy': 'year' }}
					select={years}
					error={errors.year}
				/>

				<InputSelect
					label={
						<>
							Počet osob v bytě <sup>1</sup>
						</>
					}
					name="persons"
					value={persons}
					onChange={changeHandler('persons')}
					onBlur={validateHandler('persons')}
					passedProps={{ 'data-cy': 'persons' }}
					select={PersonsVariant}
					error={errors.persons}
				/>

				<InputSelect
					label="Velikost obce"
					name="citySize"
					value={citySize}
					onChange={changeHandler('citySize')}
					onBlur={validateHandler('citySize')}
					passedProps={{ 'data-cy': 'citySize' }}
					select={CitySizeVariant}
					error={errors.citySize}
				/>

				<InputSelect
					label="Druh bydlení"
					name="contract"
					value={contract}
					onChange={changeHandler('contract')}
					onBlur={validateHandler('contract')}
					passedProps={{ 'data-cy': 'contract' }}
					select={ContractVariant}
					error={errors.contract}
				/>

				<InputCurrency
					label={
						<>
							Náklady na bydlení <sup>2</sup>
						</>
					}
					name="cost"
					value={cost}
					onChange={changeHandler('cost')}
					onBlur={validateHandler('cost')}
					passedProps={{ min: 0, step: 1, 'data-cy': 'cost' }}
					error={errors.cost}
				/>

				<InputCurrency
					label={
						<>
							Čistý příjem <sup>3</sup>
						</>
					}
					name="income"
					value={income}
					onChange={changeHandler('income')}
					onBlur={validateHandler('income')}
					passedProps={{ min: 0, step: 1, 'data-cy': 'income' }}
					error={errors.income}
				/>

				<div css={Row}>
					<Button data-cy="submit">Výpočet</Button>
				</div>

				{result && <Result bydleni={result} />}
				{result && (
					<div css={Row}>
						<Button onClick={reset} data-cy="reset">
							Nový výpočet
						</Button>
					</div>
				)}
				<Info css={Row}>
					<p>
						<sup>1</sup> Zadává se počet osob (dospělých i dětí), které mají v daném bytě/domě
						trvalé bydliště.
					</p>

					<p>
						<sup>2</sup> Mezi náklady na bydlení se započítává nájem, zaplacené náklady za vodu,
						elektřinu, plyn apod.
					</p>

					<p>
						<sup>3</sup> Zadává se čistý příjem všech osob, které mají v daném bytě trvalé bydliště.
					</p>
				</Info>
			</Form>
		</Wrapper>
	);
};
